import type { ReactNode } from 'react'

import { Fragment } from 'react'

import { useGsap } from '@/hooks/use-gsap'
import { statementLines } from '@/constants/home'

export const Statement = (): ReactNode => {
    const scope = useGsap<HTMLElement>(({ gsap, select, scope: root, reduced }) => {
        const words = select('[data-statement-word]')

        if (reduced) {
            gsap.set(words, { opacity: 1 })
            return
        }

        // Each word lifts out of the muted baseline as the section scrubs past.
        gsap.fromTo(
            words,
            { opacity: 0.28 },
            {
                opacity: 1,
                ease: 'none',
                stagger: 0.6,
                scrollTrigger: {
                    trigger: root,
                    start: 'top 78%',
                    end: 'bottom 62%',
                    scrub: 0.7
                }
            }
        )
    })

    return (
        <section ref={scope} id='promise' className='bg-sage py-24 md:py-40'>
            <h2 className='type-h1 shell-x mx-auto max-w-[19ch] text-center text-ink'>
                {statementLines.map((line, lineIndex) => (
                    <span key={line} className='block'>
                        {line.split(' ').map((word, wordIndex, all) => (
                            <Fragment key={`${word}-${wordIndex}`}>
                                <span data-statement-word='' className='inline-block'>
                                    {word}
                                </span>

                                {wordIndex < all.length - 1 ? ' ' : null}
                            </Fragment>
                        ))}

                        {lineIndex < statementLines.length - 1 ? ' ' : null}
                    </span>
                ))}
            </h2>
        </section>
    )
}
